import Immutable from 'seamless-immutable'

const initialState = Immutable({})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'ORG_TYPE_CHANGE':
      return state.set('orgType', payload)
        .set('specId', null)
        .set('subjId', null)
        .set('pimId', null)
        .set('pimStruct', null)
        .set('sort', 'alf')
        .set('activeStructure', 'fullStructure')

    case 'SET_SPEC_KODES':
      return state.set('specialities', payload)

    case 'SET_SPEC_ID':
      return state.set('specId', payload)
        .set('subjId', null)
        .set('pimId', null)
        .set('pimStruct', null)
        .set('activeStructure', 'fullStructure')

    case 'CHANGE_DISCIPLNE_SORT':
      return state.set('sort', payload)
        .set('subjId', null)
        .set('pimId', null)
        .set('pimStruct', null)

    case 'SET_SUBJS':
      return state.set('subjs', payload)

    case 'SET_SUBJ_ID':
      return state.set('subjId', payload)
        .set('pimId', null)
        .set('pimStruct', null)
        .set('activeStructure', 'fullStructure')

    case 'SET_PIM_OPTIONS':
      return state.set('pimId', payload.id)
        .set('isConstructor', payload.isConstructor)
        .set('activeStructure', 'fullStructure')

    case 'SET_PIM_STRUCT':
      return state.set('pimStruct', payload)

    case 'CHANGE_STRUCTURE':
      return state.set('activeStructure', payload)

    default:
      return state
  }
}